import { FC, useState } from "react";
import { CircleProps, DetailProps, ViewProps } from "../types";
import { ComponentCmsDataInteractiveImageMap } from "@/generated";

export type WithDataProps = {
  circles: CircleProps[];
  details: DetailProps | null;
  setDetails: (details: DetailProps | null) => void;
  image: string;
};

export const withData = (View: FC<WithDataProps>) => (props: ViewProps) => {
  const [details, setDetails] = useState<DetailProps | null>(null);

  const interactiveProps =
    props as unknown as ComponentCmsDataInteractiveImageMap & {
      interactiveImageMapImage: {
        data: {
          attributes: { url: string };
        };
      };
    };

  const circles =
    interactiveProps?.circles?.map((circle) => ({
      id: circle?.id,
      x: circle?.position_x,
      y: circle?.position_y,
      radius: circle?.radius,
      details: {
        title: circle?.details?.title,
        description: circle?.details?.description || undefined,
        image:
          circle?.details?.image?.data?.attributes?.formats?.thumbnail?.url,
        hoverIcon:
          circle?.details?.hover_icon?.data?.attributes?.formats?.thumbnail
            ?.url,
        nonHoverIcon:
          circle?.details?.non_hover_icon?.data?.attributes?.formats?.thumbnail
            ?.url,
      },
    })) || [];

  return (
    <View
      {...props}
      circles={circles}
      details={details}
      setDetails={setDetails}
      image={
        interactiveProps?.interactiveImageMapImage?.data?.attributes?.url || ""
      }
    />
  );
};
